import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastProvider } from './context/ToastContext';

// Layout components
import TopStrip     from './components/TopStrip';
import Navbar       from './components/Navbar';
import Footer       from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';

// Pages
import Home       from './pages/Home';
import About      from './pages/About';
import Services   from './pages/Services';
import Portfolio  from './pages/Portfolio';
import Team       from './pages/Team';
import Products   from './pages/Products';
import Blog       from './pages/Blog';
import Careers    from './pages/Careers';
import Contact    from './pages/Contact';
import NotFound   from './pages/NotFound';

// Global styles
import './styles/globals.css';

/* ── Scroll to top on every route change ── */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}

/* ── Page wrapper — adds entry animation ── */
function PageWrapper({ children }) {
  const { pathname } = useLocation();
  return (
    <div key={pathname} className="page-enter">
      {children}
    </div>
  );
}

/* ── App shell ── */
function AppShell() {
  return (
    <>
      <ScrollToTop />
      <TopStrip />
      <Navbar />
      <PageWrapper>
        <Routes>
          <Route path="/"          element={<Home />} />
          <Route path="/about"     element={<About />} />
          <Route path="/services"  element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/team"      element={<Team />} />
          <Route path="/products"  element={<Products />} />
          <Route path="/blog"      element={<Blog />} />
          <Route path="/careers"   element={<Careers />} />
          <Route path="/contact"   element={<Contact />} />
          <Route path="*"          element={<NotFound />} />
        </Routes>
      </PageWrapper>
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <ToastProvider>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </ToastProvider>
    </HelmetProvider>
  );
}
